import Upload from '../views/Upload/Upload.view';

export default Upload;
